import src from '../assets/thegreenjacketgolf-dark.png';
import { imageLogo } from './imageLogo';

export const GreenJacketGolfDarkLogo = imageLogo({
  src,
  width: 617,
  height: 569,
  alt: 'The Green Jacket',
});
